var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFooterhash = function SvgFooterhash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#F1F3F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m10.467 14.3.766-4.6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#405261",
    fillRule: "evenodd",
    d: "m12.768 14.3.766-4.6z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m12.768 14.3.766-4.6M14.534 10.867H9.867M14.134 13.133H9.467M16.243 7.757a6 6 0 1 1-8.485 8.486 6 6 0 0 1 8.485-8.486"
  })));
};
export { SvgFooterhash as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiNjE0YzU1MDljM2I0ZTY1OTEzOGY0NGIyMjJmMzQzMjIuc3ZnIjs=";